var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route-progress-dummy"},[(_vm.sampleVehicle)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":(_vm.kioskFrontendUrl + "/#/mac/" + (_vm.sampleVehicle.id) + "?testing=true")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }